// import { styled, alpha } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
// import Button from '@mui/material/Button';
// import Link from '@mui/material/Link';
import {
	Divider,
	// Card,
	// CardContent,
	// CardMedia,
	// Dialog,
	// DialogTitle,
	// FormControl,
	// MenuItem,
	// Select,
	// TextField,
	Typography,
	// TooltipProps,
} from '@mui/material';
// import Box, { BoxProps } from '@mui/material/Box';
// import InputBase from '@mui/material/InputBase';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const StyledTypographyFooter = styled(Typography)({
	fontWeight: '700',
	textAlign: 'start',
});
export const StyledDivider = styled(Divider)({
	width: '40%',
	border: '1.5px solid #CD3131',
	opacity: 1,
	marginBottom: '10px',
});
export const StyledDivider2 = styled(Divider)({
	width: '40%',
	border: '1.5px solid #CD3131',
	opacity: 1,
	// marginBottom: '10px',
});
// Usage example:
// <StyledTypographyFooter variant="h1">Your Text</StyledTypographyFooter>
